import React, { useState, useEffect } from "react";
import "../blockpay.css";
import Img from "../../images/Group 1171280553.svg";
import Logo from "../../images/logo 01.png";
import AppStore from "../../images/App Store.svg";
import Gplay from "../../images/Google Play.svg";
import Grid from "@mui/material/Unstable_Grid2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import {
  Card,
  CardContent,
  TextField,
  Button,
  Box,
  Typography,
  InputAdornment,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

export default function Verify() {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const verifyOtp = (e) => {
    e.preventDefault();
    axios
      .post("http://15.206.88.69:80/user/verify", {
        email: localStorage.getItem("email"),
        otp: otp,
      })
      .then((res) => {
        console.log(res.data);
        toast.success("Yay! Signup Successful!!!",{ containerId: "second" });
        navigate("/dashboard", { replace: true });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const sendOtp = (e) => {
    e.preventDefault();
    axios
      .post("http://15.206.88.69:80/user/sendOtp", {
        email: localStorage.getItem("email"),
      })
      .then((res) => {
        toast.success("OTP code sent!");
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      <ToastContainer
        position="top-center"
        enableMultiContainer
        autoClose={3000}
      />
      <ToastContainer
            enableMultiContainer
            autoClose={3000}
            containerId="second"
            position="top-center"
          />
      
      <Grid container className="loginGrid">
        <Grid xs={12} md={6} lg={6}>
          <img src={Img} className="loginImg" />
        </Grid>
        <Grid xs={12} md={6} lg={6} className="loginGridCol2">
          <Box className="loginCard">
            <CardContent>
              <img src={Logo} className="loginLogoImg" />
              <Box
                sx={{
                  fontSize: "h4.fontSize",
                  fontWeight: "bold",
                  marginBottom: 3,
                }}
              >
                Sign up
              </Box>
              <form onSubmit={verifyOtp}>
                <TextField
                  className="logintextField"
                  onChange={(e) => setOtp(e.target.value)}
                  label="Enter OTP"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Link onClick={sendOtp} className="signupVerify">
                          Get Code
                        </Link>
                      </InputAdornment>
                    ),
                  }}
                />
                <p className="verifyText">
                  Enter the 6-digit verification code for ****@gmail.com
                </p>

                <Button
                  className="loginButtonSignUp"
                  variant="contained"
                  color="primary"
                  size="large"
                  type="submit"
                >
                  <span className="buttonSignText">Verify</span>
                </Button>
              </form>
            </CardContent>
          </Box>
          <Box className="loginCard2">
            <CardContent sx={{ fontSize: 19 }}>
              Already have an account?{" "}
              <span>
                <Link to="/signin" className="underline">
                  Log in
                </Link>
              </span>
            </CardContent>
          </Box>
          <Box className="loginCard3">
            <Grid container spacing={4} className="loginGrid1-2">
              <Grid
                xs={6}
                md={6}
                lg={6}
                sx={{ paddingRight: 1, paddingLeft: 0 }}
              >
                <img src={AppStore} className="loginAppImg" />
              </Grid>
              <Grid
                xs={6}
                md={6}
                lg={6}
                sx={{ paddingLeft: 1, paddingRight: "0!important" }}
              >
                <img src={Gplay} className="loginAppImg" />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
